<template>
<v-container fluid grid-list-md style="padding: 30px;">
  <v-row>
    <v-col cols="12" sm="12" md="6">
      <v-select outlined dense v-model="eventoId" :items="eventos" item-text="nome" item-value="id" label="Selecione o Evento" @input="carregaAssociacoes()" color="#0D47A1"></v-select>
    </v-col>
    <!-- <v-col cols="12" sm="12" md="6" style="text-align: right">
      <v-btn @click="criaVigilante" color="#7B1FA2" style="color: #ffffff">
        <v-icon left dark>add_circle</v-icon>Cadastrar Vigilante
      </v-btn>
    </v-col> -->
  </v-row>
  <v-data-table :search="search" :headers="headers" :items="associacoes" sort-by="nome" class="elevation-1" style="border-radius: 10px;">
    <template v-slot:top>
      <v-toolbar flat color="white" style="border-radius: 10px;">
        <v-toolbar-title class="textoUser">CONVOCAÇÕES</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="Pesquisa" single-line hide-details></v-text-field>
      </v-toolbar>
    </template>
    <template v-slot:item.action="{ item }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon @click="openDialog(item)" v-bind="attrs" v-on="on">check_circle</v-icon>
        </template>
        <span>Aprovar/Recusar</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon @click="deleteItem(item)" v-bind="attrs" v-on="on">delete</v-icon>
        </template>
        <span>Excluir</span>
      </v-tooltip>
    </template>
    <template slot="no-data">
      <v-row>
        <v-col>
          <v-alert dark dense text outlined :value="true" color="warning" icon="info">Nenhuma solicitação de convocação para este evento</v-alert>
        </v-col>
      </v-row>
    </template>
    <template slot="no-results">
      <v-row>
        <v-col>
          <v-alert dark dense text outlined :value="true" color="warning" icon="info">Nenhuma solicitação encontrada</v-alert>
        </v-col>
      </v-row>
    </template>
  </v-data-table>
  <br>
  <v-card-actions>
    <v-btn color="#7B1FA2" @click="carregaAssociacoes" style="color: #ffffff">
      <v-icon left>sync</v-icon>Recarregar
    </v-btn>
    <v-btn color="#7B1FA2" style="color: #ffffff" v-if="impressaoPronta">
      <download-csv :data="listaAssociacoes" name="Relatorio_Vigilantes.csv">
        <v-icon left>cloud_download</v-icon>Imprimir
      </download-csv>
    </v-btn>
  </v-card-actions>
  <loading :active.sync="isLoading" :can-cancel="true" color="#7B1FA2" :is-full-page="fullPage"></loading>
  <Snackbar ref=chamaSnackbar />
</v-container>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import moment from 'moment'
  import axios from 'axios'
  import { mapState } from 'vuex'
  export default {
    components: { Snackbar, Loading, },
    data: () => ({
      cadastroVigilante: false,
      eventoId: '',
      eventoIdAtual: '',
      fullPage: true,
      isLoading: false,
      loading: false,
      search: '',
      nome: '',
      checkin: {
        cod_incricao: '',
        tipo: '',
        eventoId: ''
      },
      qualificacoes: ['APOIO', 'VIGILANTE BÁSICO', 'VIGILANTE DE GRANDES EVENTOS'],
      sexos: ['MASCULINO', 'FEMININO'],
      headers: [
        { text: 'Nome', align: 'start', value: 'nome' },
        { text: 'CPF', value: 'cpf' },
        { text: 'Sexo', value: 'sexo' },
        { text: 'Telefone', value: 'telefone' },
        { text: 'E-mail', value: 'email' },
        { text: 'Qualificação', value: 'qualificacao' },
        { text: 'Última Consulta PF', value: 'ultimaConsultaPF' },
        { text: 'Status', value: 'status' },
        { text: 'Realizada em', value: 'created' },
        { text: 'Ações', value: 'action', align: 'center', sortable: true }
      ],
      editedIndex: -1,
      eventos: [],
      vigilantes: [],
      editaPassos: false,
      passos: 1,
      filesRg1: [],
      filesRg2: [],
      filesCpf: [],
      filesReciclagem: [],
      filesPessoal: [],
      associacoes: [],
      listaAssociacoes: [],
      impressaoPronta: false,
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitle() {
        return this.editedIndex === -1 ? 'ADICIONAR VIGILANTE' : 'EDITAR VIGILANTE'
      }
    }),

    mounted() {
      this.carregaEventos()
    },

    methods: {
      async carregaEventos() {
        this.isLoading = true
        await axios.get(`${baseApiUrl}Eventos?filter={"where":{"empresaId":"${this.companyobj.id}"}, "order":"inicio DESC"}`).then(res => {
          if (res.data != '') {
            for (var key in res.data) {
              if (res.data.hasOwnProperty(key)) {
                this.eventos.push(res.data[key])
              }
            }
            this.eventos = this.eventos.sort(this.compare)
            this.eventoId = this.eventos[0].id
            if (this.eventoIdAtual != '')
              this.eventoId = this.eventoIdAtual
          } else
            this.isLoading = false
        })
        await this.carregaAssociacoes()
      },

      async carregaAssociacoes() {
        this.impressaoPronta = false
        this.isLoading = true
        try {
          this.associacoes = []
          await axios.post(`${baseApiUrl}AssociacoesEvento/listaConvocacao`, {"eventoId": this.eventoId}).then(response => {
            if (response.data) {
              this.associacoes = response.data
              this.listaAssociacoes = []
              for (let i = 0; i < response.data.length; i++) {
                this.listaAssociacoes.push({
                  "NOME": response.data[i].nome,
                  "CPF": response.data[i].cpf,
                  "SEXO": response.data[i].sexo,
                  "TELEFONE": response.data[i].telefone,
                  "E-MAIL": response.data[i].email,
                  "QUALIFICAÇÃO": response.data[i].qualificacao,
                  "STATUS": response.data[i].status,
                  "CURSO":  this.verificaVencimento(response.data[i].validadeCurso),
                  "VALIDADE CURSO": response.data[i].validadeCurso,
                  "ÚLTIMA CONSULTA PF": response.data[i].ultimaConsultaPF
                })
              }
            }
          })
          this.impressaoPronta = true
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao buscar associações, tente novamente", "DESCULPE")
        }
      },

      verificaVencimento (data) {
        if (data) {
          if (moment(this.formatoData(data)).isAfter() == true) {
            return 'EM DIA'
          } else if (moment(this.formatoData(data)).isAfter() == false) {
            return 'VENCIDO'
          }
        } else {
          return 'NÃO INFORMADO'
        }
      },

      compare(a) {
        // Use toUpperCase() to ignore character casing
        const dataA = moment(this.formatDateHora(a.fim), 'DD/MM/YYYY HH:mm:ss', true).format()
        //const dataB = new Date(moment(this.formatDatePadrao(b.fim)).format('YYYY-MM-DDTHH:mm:ss.000Z').replace('-03:00', 'Z'))
        const dataC = moment().format()

        let comparison = 0;
        if (dataC >= dataA)
          comparison = 1;
        /* else
          if (dataA >= dataC && dataB < dataA)
            comparison = -1; */
        else
        if (dataC < dataA)
          comparison = -1;
        return comparison;
      },

      formatDate(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDateHour(data_hora) {
        let data = data_hora.substr(0, 10).split('-')
        data = data[2] + '/' + data[1] + '/' + data[0]
        let hora = data_hora.substr(11, 8)

        return data + ' ' + hora

      },

      formatDateBrz(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDatePadrao(date) {
        if (!date) return null

        const [day, month, year] = date.substr(0, 10).split('/')
        return `${year}-${month}-${day}` + " " + date.substr(11, 6)
      },

      formatoData(date) {
        if (!date) return null

        const [day, month, year] = date.substr(0, 10).split('/')
        return `${year}-${month}-${day}`
      },

      formatDateHora(date) {
        if (!date) return null

        const [year, month, day] = date.substr(0, 10).split('-')
        return `${day}/${month}/${year}` + " " + date.substr(11, 8)
      },

      async openDialog(item) {
        if (item.status == 'EM ANÁLISE') {
          var r = confirm('Deseja aprovar a convocação do(a) vigilante ' + item.nome + '?')
          if (r == true) {
            this.isLoading = true
            await axios.patch(`${baseApiUrl}AssociacoesEvento/${item.id}`, {"status":"APROVADO"})
            .then(() => {
              var vm = this
              vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
              this.eventoIdAtual = this.eventoId
              this.carregaAssociacoes()
            }).catch(() => {
              this.isLoading = false
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
            })
          }
        } else if (item.status == 'APROVADO') {
          r = confirm('O vigilante ' + item.nome + ' encontra-se com situação APROVADO. Deseja alterar para RECUSADO?')
          if (r == true) {
            this.isLoading = true
            await axios.patch(`${baseApiUrl}AssociacoesEvento/${item.id}`, {"status":"RECUSADO"})
            .then(() => {
              var vm = this
              vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
              this.eventoIdAtual = this.eventoId
              this.carregaAssociacoes()
            }).catch(() => {
              this.isLoading = false
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
            })
          }
        } else if (item.status == 'RECUSADO') {
          r = confirm('O vigilante ' + item.nome + ' encontra-se com situação RECUSADO. Deseja alterar para APROVADO?')
          if (r == true) {
            this.isLoading = true
            await axios.patch(`${baseApiUrl}AssociacoesEvento/${item.id}`, {"status":"APROVADO"})
            .then(() => {
              var vm = this
              vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
              this.eventoIdAtual = this.eventoId
              this.carregaAssociacoes()
            }).catch(() => {
              this.isLoading = false
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
            })
          }
        }
      },

      async deleteItem(item) {
        var r = confirm('Deseja realmente excluir a solicitação de convocação de ' + item.nome + '?')
        if (r == true) {
          this.isLoading = true
          await axios.delete(`${baseApiUrl}AssociacoesEvento/${item.id}`)
          .then(() => {
            var vm = this
            vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
            this.eventoIdAtual = this.eventoId
            this.carregaAssociacoes()
          }).catch(() => {
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
          })
        }
      },
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  @font-face {
    font-family: Roboto;
    src: url('https://fonts.google.com/specimen/Roboto');
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px;
    width: 120px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
  }
</style>